import { ListItem, ListItemText, Stack, Typography } from "@mui/material"
import { formatMacroDateTime } from "authoring/routes/macro/lib/macro-formatters"
import { useUser } from "lib/user/use-user"

export function MacroHistoryItem({ entry }) {
    const { user } = useUser(entry?.changedBy)
    if (!entry) return null

    const changedByLabel = resolveUserLabel(user)

    return (
        <ListItem divider disableGutters data-cy={`macro-history-item-${entry.version}`}>
            <ListItemText
                primary={
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="subtitle2" data-cy="macro-history-version">
                            Version {entry.version ?? "?"}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" data-cy="macro-history-date">
                            {formatMacroDateTime(entry.changedAt)}
                        </Typography>
                    </Stack>
                }
                secondary={
                    <Stack spacing={0.25}>
                        <Typography variant="caption" color="text.secondary" data-cy="macro-history-changed-by">
                            {`Changed by ${changedByLabel}`}
                        </Typography>
                    </Stack>
                }
            />
        </ListItem>
    )
}

function resolveUserLabel(user) {
    if (user?.displayName) return user.displayName
    if (user?.email) return user.email
    return "unknown user"
}
